import React from "react";
import { InMemoryDownload } from "../InMemoryDownload";
import { Release } from "../../models";
import { ReleaseFileList } from "./ReleaseFileList";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function Tr3FirmwareFileList({ releaseFiles, release }: Props) {
  return (
    <>
      <td>
        {releaseFiles.releaseAppAndBootloaderDevKeys && (
          <>
            <InMemoryDownload
              displayName="App + Bootloader (Dev Keys)"
              fileName={`app-bootloader-bundle-dev_${release.version}.bin`}
              content={releaseFiles.releaseAppAndBootloaderDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseAppAndBootloaderProdKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="App + Bootloader (Prod Keys)"
              fileName={`app-bootloader-bundle-prod_${release.version}.bin`}
              content={releaseFiles.releaseAppAndBootloaderProdKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseAppOnlyEncryptedDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="OTA Updateable App (Dev Keys)"
              fileName={`halo-dev_${release.version}.sfb`}
              content={releaseFiles.releaseAppOnlyEncryptedDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseAppOnlyEncryptedProdKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="OTA Updateable App (Prod Keys)"
              fileName={`halo-prod_${release.version}.sfb`}
              content={releaseFiles.releaseAppOnlyEncryptedProdKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseAppOnly && (
          <>
            <br />
            <InMemoryDownload
              displayName="Unencrypted App Firmware (bin)"
              fileName={`halo_${release.version}.bin`}
              content={releaseFiles.releaseAppOnly?.data}
            />
          </>
        )}
        {release.releaseMeta && (
          <>
            <br />
            <InMemoryDownload
              displayName="Metadata"
              fileName="metadata.json"
              content={window.btoa(release.releaseMeta)}
            />
          </>
        )}
      </td>

      <td></td>

      <td>
        {releaseFiles.releaseAppOnlyElf && (
          <>
            <InMemoryDownload
              displayName="Application ELF"
              fileName={`${release.version}.elf`}
              content={releaseFiles.releaseAppOnlyElf?.data}
            />
          </>
        )}
        {releaseFiles.releaseMfgElf && (
          <>
            <br />
            <InMemoryDownload
              displayName="Manufacturing Elf"
              fileName="mfg.elf"
              content={releaseFiles.releaseMfgElf?.data}
            />
          </>
        )}
      </td>
    </>
  );
}
